import React, { useEffect, useState } from "react";
import DynamicForm from "../../../../../customformComponent/customForm/DynamicForm";
import backicon from './../../../../../../Assets/icons/backIcon.svg';
import "./index.scss";
import { useNavigate } from "react-router-dom";
import ROUTES_NAVIGATION from "../../../../../../routes/routes";
import axiosInstance from "../../../../../services/api/API";
import { toastSuccess } from "../../../../../customComponents/customToast/Toast";
import { ToastContainer } from "react-toastify";
import { showCustomAlert } from "../../../../../customComponents/CustomSweetAlert";
import { showErrorAlert } from "../../../../../customComponents/CustomSweetAlert/errorsweetalert";

const AddNewRTO = () => {
  const [formData, setFormData] = useState({});
  const [isFormSubmitted, setIsFormSubmitted] = useState(false);
  const [isLoading, setIsLoading] = useState(false);
  const [validationErrors, setValidationErrors] = useState({});

  const [ stateVal, setStateVal  ] = useState([])
  const [ cityIdVal, setCityIdVal ] = useState([])

  const [ cityValueData, setCityValueData  ] = useState([])

  const navigate = useNavigate();

  const token = localStorage.getItem("authToken");


  useEffect(() => {
    fetchStateList()
  },[])

  const fetchStateList = async () => {
    try{
      const response = await axiosInstance.get("/pincodestatecity/stateList",{
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${token}`,
        },
      })
  
      const data = response?.data?.data
      console.log(data, "stateOptions")
      const stateOptions = data?.map(state => ({
        value: state.state_id,
        label:state.state_name,
      }))
      setStateVal(stateOptions)
    }catch(error){
      console.log(error)
    }
  }

  useEffect(() => {
    
    if(formData.stateid){
      console.log(formData.stateid, "StateIdVAL")
      const stateId = formData.stateid
      setCityIdVal(stateId)
      fetchCityList()
    }
  },[formData.stateid])

  const fetchCityList = async () => {
    try{
      const response = await axiosInstance.get(`pincodestatecity/cityList/${formData?.stateid}`,{
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${token}`,
        },
      })
  
      const data = response?.data?.data
      console.log(data, "stateOptions")
      const stateOptions = data?.map(state => ({
        value: state.city_id,
        label:state.city_name,
      }))
      setCityValueData(stateOptions)
    }catch(error){
      console.log(error)
    }
  }

  const handleFormSubmit = async (formData) => {
    const errors = {};
    let isValid = true;

    RTOInputs.forEach((field) => {
      if (field.validation && field.validation.required) {
        if (!formData[field.name]) {
          errors[field.name] = "This field is required";
          isValid = false;
        }
      }
    });

    if (!isValid) {
      setValidationErrors(errors);
      return;
    }
    setIsLoading(true);
    console.log("formData",formData);

    showCustomAlert({
      title: "Success",
      text: "Do you want to create this department?",
      icon: "success",
      confirmButtonText: "Yes",
      cancelButtonText: "No",
      callback: async () => {

    try {
      const response = await axiosInstance.post('/rto/create',{
        rtocode: formData.rtocode,
        rtolabel:formData.rtolabel,
        groupcode:formData.groupcode,
        rtocity:formData.rtocity,
        cityid:formData.cityid,
        stateid:formData.stateid,
        zonetypeid:1,
        commercialzonetypeid:1,
        isncr: 0,
        status: formData.status === "Active" ? 1 : 0,
      },
      {
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${token}`,
        }
      }
    );
  
      console.log("Unit added successfully:", response.data);
      if (response.status === 200) {
 
        navigate('/admin/manage-dealer/rto'); 

  }
      // toastSuccess(" Data fetched successfully!"); 
      
    } catch (error) {
      console.error('Error adding unit:', error);
      const errorMessage = error.response?.data?.message
      showErrorAlert({
        title: "Something went wrong",
        text: errorMessage || "An error occurred while processing your request.",
        callback: () => { 
          // Optional: code to execute after confirming the alert
          console.log("Error alert confirmed");
        }
      });
     
    }
  },
});        
  };
  
  const RTOInputs = [
    {
      name: "rtocode",
      label: "RTO Code",
      placeholder:"Enter RTO Code",
      type: "text",
      required: true,
      gridClass: "col-lg-4",
      validation: { required: true,
        pattern: /^[A-Za-z0-9 ]*$/,
        message: "Only alphabets and digits are allowed",
       },
    },
    {
      name: "rtolabel",
      label: "RTO Label",
      placeholder:"Enter RTO Label",
      type: "text",
      required: true,
      gridClass: "col-lg-4",
      validation: { required: true },
    },
    {
      name: "groupcode",
      label: "Group Code",
      placeholder:"Enter Group Code",
      type: "text",
      // required: true,
      gridClass: "col-lg-4",
      // validation: { required: true },
    },
    {
      name: "rtocity",
      label: "RTO City",
      type: "text",
      required: true,
      gridClass: "col-lg-4",
      validation: { required: true },
    },
    {
      name: "stateid",
      label: "State",
      type: "dropdown",
      options: stateVal ,
      required: true,
      gridClass: "col-lg-4",
      validation: { required: true },
    },
    {
      name: "cityid",
      label: "City",
      type: "dropdown",
      required: true,
      options:cityValueData  ,
      gridClass: "col-lg-4",
      validation: { required: true },
    },
    // {
    //   name: "zonetypeid",
    //   label: "ZoneType Id",
    //   type: "number",
    //   required: true,
    //   gridClass: "col-lg-4",
    //   validation: { required: true },
    // },
    // {
    //   name: "commercialzonetypeid",
    //   label: "Commercial Zone Type Id",
    //   type: "number",
    //   required: true,
    //   gridClass: "col-lg-4",
    //   validation: { required: true },
    // },
    // {
    //   name: "isncr",
    //   label: "ISNCR",
    //   type: "number",
    //   required: true,
    //   gridClass: "col-lg-4",
    //   validation: { required: true },
    // },
    {
      name: "status",
      label: "Status Name",
      type: "dropdown",
      required: true,
      options: [
        { id: 1, label: "Active", value: "Active" },
        { id: 0, label: "Inactive", value: "Inactive" },
      ],
      gridClass: "col-lg-4",
      validation: { required: true },
    },
  ];

  return (
    <>
    <ToastContainer />
      <div className="backbutton mt-2 mb-2" onClick={() => navigate(-1)}>
        <img src={backicon} alt="back" />
        <span className="backbtntitle">Add New RTO</span>
      </div>
      <div className="form-container">
        <span className="cust-det-title mt-2 mb-2">
          Please Enter RTO Details
        </span>
        <DynamicForm
          formConfig={RTOInputs}
          formData={formData}
          setFormData={setFormData}
          onSubmit={handleFormSubmit}
          validationErrors={validationErrors}
          setValidationErrors={setValidationErrors}
        />
      </div>
      <div className="btncontainer mt-3">
        <button
          onClick={() => {
            if (!isFormSubmitted) {
              handleFormSubmit(formData); // Call handleFormSubmit if isFormSubmitted is false
            }
          }}
          className="submit-btn"
        >
          Submit
        </button>
      </div>
    </>
  );
};

export default AddNewRTO;
